<template>
    <el-card class="collectWrapper">
        <div class="tab">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleTabSelect">
                <el-menu-item index="0">全部</el-menu-item>
                <el-menu-item index="2">视频</el-menu-item>
                <el-menu-item index="4">音频</el-menu-item>
                <el-menu-item index="1">文档</el-menu-item>
            </el-menu>
        </div>
        <div class="tab-content">
            <collect-tab :active-index="activeIndex"/>
        </div>
    </el-card>
</template>
<script>
  import collectTab from '@/components/Collect/collectTab'

  export default {
    name: 'Collection',
    components: { collectTab },
    data() {
      return {
        activeIndex: '0'
      }
    },
    methods: {
      handleTabSelect(key) {
        this.activeIndex = key
      }
    }
  }
</script>
<style lang="scss" scoped>
    .collectWrapper {
        .tab{
            margin:0 15px;
        }
        .tab-content{
            margin:20px 15px;
        }
    }
</style>
